import React from 'react';
import { FileUp, CheckCircle, Server } from 'lucide-react';

const UploadProgress = ({ progress }) => {
  // Calculate which stage we're in based on progress
  const uploadingStage = progress <= 40;
  const processingStage = progress > 40 && progress <= 80;
  const finalizingStage = progress > 80;
  
  return (
    <div className="landing-gradient flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full bg-dark rounded-2xl p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-center mb-6">
          Compliance Agent
        </h1>
        
        <div className="mb-8">
          <div className="h-3 bg-dark-lighter rounded-full overflow-hidden">
            <div 
              className="h-full bg-primary transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-right mt-2 text-sm text-gray-400">{progress}%</p>
        </div>
        
        <div className="space-y-6">
          {/* Upload Stage */}
          <div className="flex items-center">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              uploadingStage 
                ? 'bg-primary text-white' 
                : 'bg-green-500 text-white'
            }`}>
              {uploadingStage ? (
                <FileUp size={20} className="animate-pulse" />
              ) : (
                <CheckCircle size={20} />
              )}
            </div>
            <div className="ml-4">
              <h3 className="font-medium">Uploading Document</h3>
              <p className="text-sm text-gray-400">
                {uploadingStage ? 'Transferring your PDF...' : 'Upload complete'}
              </p>
            </div>
          </div>
          
          {/* Processing Stage */}
          <div className="flex items-center">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              processingStage
                ? 'bg-primary text-white'
                : processingStage || finalizingStage
                  ? 'bg-green-500 text-white'
                  : 'bg-dark-lighter text-gray-500'
            }`}>
              {processingStage ? (
                <Server size={20} className="animate-pulse" />
              ) : finalizingStage ? (
                <CheckCircle size={20} />
              ) : (
                <Server size={20} />
              )}
            </div>
            <div className="ml-4">
              <h3 className="font-medium">Processing Document</h3>
              <p className="text-sm text-gray-400">
                {processingStage 
                  ? 'Analyzing PDF content...' 
                  : finalizingStage 
                    ? 'Processing complete' 
                    : 'Waiting to process...'}
              </p>
            </div>
          </div>
          
          {/* Finalizing Stage */}
          <div className="flex items-center">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              finalizingStage
                ? 'bg-primary text-white animate-pulse'
                : 'bg-dark-lighter text-gray-500'
            }`}>
              <CheckCircle size={20} />
            </div>
            <div className="ml-4">
              <h3 className="font-medium">Preparing Session</h3>
              <p className="text-sm text-gray-400">
                {finalizingStage 
                  ? 'Setting up your interactive session...' 
                  : 'Waiting to initialize...'}
              </p>
            </div>
          </div>
        </div>
        
        <p className="text-center mt-8 text-sm text-gray-400">
          {progress < 100 
            ? "Please wait while we prepare your document..." 
            : "Almost ready!"}
        </p>
      </div>
    </div>
  );
};

export default UploadProgress;